// shared-components/ui/Toast.jsx
import { useState } from "react";
import PropTypes from "prop-types";
import { TYPOGRAPHY } from "@shared/constants/designSystem";

// eslint-disable-next-line react-refresh/only-export-components
export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "info") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 5000);
  };

  const toast = {
    success: (message) => showToast(message, "success"),
    error: (message) => showToast(message, "error"),
    info: (message) => showToast(message, "info"),
  };

  return { toasts, toast };
};

export const ToastContainer = ({ toasts }) => {
  return (
    <div className="fixed top-4 right-4 lg:top-6 lg:right-6 z-[9999] space-y-2 max-w-sm lg:max-w-md">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            p-4 rounded-lg shadow-lg w-full transform transition-transform duration-300 animate-in slide-in-from-right
            ${toast.type === "success" ? "bg-green-500 text-white" : ""}
            ${toast.type === "error" ? "bg-red-500 text-white" : ""}
            ${toast.type === "info" ? "bg-blue-500 text-white" : ""}
          `}
        >
          <p className={TYPOGRAPHY.BODY.DEFAULT}>{toast.message}</p>
        </div>
      ))}
    </div>
  );
};

ToastContainer.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["success", "error", "info"]).isRequired,
    }),
  ).isRequired,
};
